import { useSyncExternalStore } from "react";

/**
 * Tiny shared store: the chart publishes the candles it is showing, and the quant strip,
 * Quant panel and range gauge read them. Going through a store (instead of props) means
 * a live tick never re-renders the whole chart page. Updates are throttled to 4 per second.
 */
let snapshot = { candles: [], symbol: "", timeframe: "", barSeconds: 0, regimeTrendThreshold: 0.4, regimeRangeThreshold: 0.25, regimePeriod: 20, regimeSmooth: 5, regimeModel: "kaufman", regimeCurrent: "", regimeValidation: null, version: 0 };
let pending = null;
let timer = null;
const listeners = new Set();

function flush() {
  timer = null;
  if (!pending) return;
  snapshot = { ...pending, version: snapshot.version + 1 };
  pending = null;
  listeners.forEach((listener) => listener());
}

export function publishChartData(next) {
  pending = next;
  if (!timer) timer = setTimeout(flush, 250);
}

export function subscribeChartData(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getChartDataSnapshot() {
  return snapshot;
}

export function useChartData() {
  return useSyncExternalStore(subscribeChartData, getChartDataSnapshot, getChartDataSnapshot);
}
